// True while any of the given fields is empty or any field in the form shows an error - used to
// keep single-page checkout submit buttons disabled until the form can actually be submitted.
export const isFormIncomplete = (form, requiredFields = []) => {
  const values = form.getFieldsValue(requiredFields);
  const hasEmptyField = requiredFields.some((name) => {
    const value = values[name];
    return value === undefined || value === null || String(value).trim() === '';
  });
  const hasFieldError = form.getFieldsError().some(({ errors }) => errors.length > 0);
  return hasEmptyField || hasFieldError;
};
